import { MenuOpenOutlined } from "@mui/icons-material"
import IconButton from "@mui/material/IconButton"
import Typography from "@mui/material/Typography"

import Button from "@components/button"
import LeftDrawer from "@components/persist_drawer"
import SectionBar from "@components/section_bar"
import TextInput from "@components/text_input"
import { PRIMARY } from "@constants/colors"
import {
  MarketplaceOrdersFormData,
  useMarketplaceOrdersPageContext
} from "@contexts/main/marketplace_orders_page_context"
import { getCustomers } from "@domain/customer/list"
import { Stack } from "@mui/material"
import { useQuery } from "@tanstack/react-query"
import { useDebounce } from "@uidotdev/usehooks"
import { useEffect, useState } from "react"
import { useForm } from "react-hook-form"

export default function MarketplaceOrdersPageLeftDrawer() {
  const {
    isLeftDrawerOpen,
    toggleIsLeftDrawerOpen,
    translate,
    setFilters,
    filters
  } = useMarketplaceOrdersPageContext()

  const { control, handleSubmit, reset } = useForm<MarketplaceOrdersFormData>({
    defaultValues: filters
  })

  useEffect(() => {
    reset(filters)
  }, [filters, reset])

  const [searchValue, setSearchValue] = useState("")
  console.log("search value", searchValue)
  const debouncedSearch = useDebounce(searchValue, 500)

  const isSearchValid = debouncedSearch.length >= 3
  const finalSearch = isSearchValid ? debouncedSearch : ""
  console.log("final search mate", finalSearch)

  const { data: customerData, isLoading } = useQuery({
    queryKey: ["customer-data-table-marketplace-orders", finalSearch],
    queryFn: async () => {
      console.log("is search valid mate", isSearchValid)
      console.log("final search valid mate", finalSearch)
      const response = await getCustomers({
        pageNumber: 0,
        pageSize: isSearchValid ? 25 : 1000,
        // pageSize: 1000,
        search: finalSearch
        // search: undefined
      })
      return response.data
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false
  })

  const onSubmit = (data: MarketplaceOrdersFormData) => {
    const finalFilters = {
      ...data,
      filterTrigger: Date.now()
    }
    setFilters(finalFilters)
  }

  return (
    <LeftDrawer
      isOpen={!!isLeftDrawerOpen}
      header={<Header setClose={toggleIsLeftDrawerOpen} />}
      sx={{
        borderRight: 1,
        borderColor: "divider",
        width: "16rem",
        minWidth: "16rem",
        maxWidth: "16rem"
      }}
    >
      <Stack gap={2} p={2}>
        <TextInput
          control={control}
          name="customerId"
          placeholder={translate("select")}
          type="select"
          label={translate("customer")}
          loading={isLoading}
          onInputChange={(_, value: string, reason) => {
            if (reason === "input") {
              console.log("yes mate", value)
              setSearchValue(value)
            }
          }}
          selectOptions={[
            { value: "ALL", label: translate("all") },
            ...(customerData?.docs
              ?.filter((item) => item.customer?.appStatus === "Enabled")
              ?.map((item) => ({
                value: item.customer?._id || "",
                label: item.customer?.companyName || ""
              }))
              .reverse() ?? [])
          ]}
        />
        <TextInput
          control={control}
          name="marketplaceType"
          placeholder={translate("select")}
          type="select"
          label={translate("marketplace")}
          loading={isLoading}
          onInputChange={(_, value: string, reason) => {
            if (reason === "input") {
              console.log("yes mate", value)
              setSearchValue(value)
            }
          }}
          selectOptions={[
            { value: "ALL", label: translate("all") },
            { value: "AMAZON", label: "Amazon" },
            { value: "EBAY", label: "Ebay" },
            { value: "WALMART", label: "Walmart" },
            { value: "KAUFLAND", label: "Kaufland" },
            { value: "PAZARAMA", label: "Pazarama" }
          ]}
        />

        <Button onClick={handleSubmit(onSubmit)}>{translate("filter")}</Button>
      </Stack>
    </LeftDrawer>
  )
}

function Header({ setClose }: { setClose?: () => void }) {
  const { translate } = useMarketplaceOrdersPageContext()

  return (
    <SectionBar
      sx={{
        justifyContent: "space-between",
        alignItems: "center",
        p: 1
      }}
    >
      <Typography p={1} variant="h6">
        {translate("marketplace_orders")}
      </Typography>
      <IconButton
        disableRipple
        sx={{
          ":hover": {
            color: PRIMARY
          }
        }}
        onClick={setClose}
      >
        <MenuOpenOutlined />
      </IconButton>
    </SectionBar>
  )
}
